export const AXON_TOOLBOX_URL = "https://tools.axongroup.com.co/";
export const AXON_SITE_URL = "https://axongroup.com.co";
export const AXON_BRACKET_COLOR = "#00d177";
export const APPS_MANIFEST_URL = "apps.json";
export const I18N_STORAGE_KEY = "axon.i18n.lang";

export const FEEDBACK_ENDPOINT =
  import.meta.env.VITE_FEEDBACK_ENDPOINT || "feedback/index.php";
export const FEEDBACK_COMMENT_MAX = 4000;
export const FEEDBACK_NAME_MAX = 200;
export const FEEDBACK_EMAIL_MAX = 320;
export const FEEDBACK_RATING_MAX = 10;
